import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import VipPopup from "./components/VipPopup";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import Services from "./pages/Services";
import SafeRide from "./pages/SafeRide";
import LuxuryAddOns from "./pages/LuxuryAddOns";
import BookOnline from "./pages/BookOnline";
import FAQs from "./pages/FAQs";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";

function ScrollAndReveal() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    els.forEach((el) => io.observe(el));
    // Fallback: reveal anything already in view
    const t = setTimeout(() => {
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add("is-visible");
      });
    }, 100);
    return () => {
      io.disconnect();
      clearTimeout(t);
    };
  }, [location.pathname]);
  return null;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname === "/admin";
  return (
    <>
      <ScrollAndReveal />
      {!isAdmin && <Navbar />}
      {!isAdmin && <VipPopup />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/saferide" element={<SafeRide />} />
          <Route path="/luxury-add-ons" element={<LuxuryAddOns />} />
          <Route path="/book" element={<BookOnline />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/terms" element={<Legal type="terms" />} />
          <Route path="/cancellation" element={<Legal type="cancellation" />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
